import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { APPNAME, SETTINGS } from 'src/common/constants';
import { SidebarState } from 'src/types/types';

// Define types
interface SettingsState {
    appName: string
    sidebarState: SidebarState
    activeSidemenu: string | null

}

// Define the initial state
const initialState: SettingsState = {
    appName: APPNAME,
    sidebarState: 'opened',
    activeSidemenu: null,
};

// Create async thunks for authentication operations


// Create the slice
const settingsSlice = createSlice({
    name: SETTINGS,
    initialState,
    reducers: {
        setSidebarState: (state, { payload }: PayloadAction<SidebarState>) => {
            state.sidebarState = payload
        },
        setActiveSidemenu: (state, { payload }: PayloadAction<string | null>) => {
            state.activeSidemenu = payload
        },
    },
    extraReducers: () => { },
});

export const { setSidebarState, setActiveSidemenu } = settingsSlice.actions
export default settingsSlice.reducer;
